import React from 'react';

const AboutMe = () => {
  return (
    <div className="container mx-auto mt-10 p-4 lg:p-6 bg-white rounded-lg shadow-lg">
      <div className="text-xl md:text-2xl lg:text-3xl mb-4 font-serif">
        <p className="mb-4">
          I am a motivated, confident, and enthusiastic professional with over 5 years of experience in the social sector. I am currently transitioning to a career in tech after successfully completing an intensive <strong>12-month software development program</strong> at CodeYourFuture in London.
        </p>
        <p className="mb-4">
          Through CodeYourFuture's immersive curriculum, I gained extensive technical skills in <strong>HTML, CSS, JavaScript, React, Node.js, PostgreSQL,</strong> and other core technologies. I am currently enhancing these skills in their Cloud module, where I am learning to use <strong>Amazon Web Services</strong> like <strong>EC2, S3, and RDS.</strong>
        </p>
        <p className="mb-4">
          My background in the social sector instilled in me a passion for helping others and making a positive impact. As a developer, I am excited to use my new skills to build accessible, user-friendly applications that can benefit society.
        </p>
        <p className="mb-4">
          Outside of programming, I enjoy outdoor activities with my husband and 9 years old son, learning foreign languages, and volunteering in my community. I am constantly seeking new challenges and opportunities for personal growth.
        </p>
      </div>
    </div>
  );
};

export default AboutMe;

